import { ViewStream } from 'spyne';
import { gsap } from 'gsap';
import { PageHomeStructuralApiTraits } from 'traits/page-home-structural-api-traits';
import StructuralAPITmpl from 'components/pages/templates/landing-templates/landing-structural-api.tmpl.html';

export class PageHomeStructuralApi extends ViewStream {

  constructor(props = {}) {
    props.traits = [PageHomeStructuralApiTraits];
    props.template = StructuralAPITmpl;
    super(props);
  }

  broadcastEvents() {
    return [
      ['.structural-api__codemap-image', 'pointerdown']
    ];
  }

  addActionListeners() {
    return [];
  }

  onRendered() {

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);


    const imgEl = this.props.el$('.structural-api__codemap-image').el;
    if (imgEl) {

      const setImgPos = ()=> gsap.set(imgEl, { y: -962.143, x: -16.5429 });
     // const setReal = ()=>imgEl.style.cssText = "transform: scale(1.25) translate(-2.8483px, -690px);";
      const setReal = ()=>imgEl.style.cssText = "transform:  translate(-8.8483px, -938px);";
      const justImg = ()=>imgEl.background="#000";
     //requestAnimationFrame(setImgPos)
    // window.setTimeout(setImgPos, 1000);
     // window.setTimeout(setImgPos, 1500);
     // window.setTimeout(setReal, 200);
      //window.setTimeout(setReal, 1200);
     // window.setTimeout(setImgPos, 5200);
      window.setTimeout(setReal, 3200);

      if (isIOS){
         this.props.el$(".structural-api__codemap-body").el.style.cssText="overflow:auto; border:1px solid #000;";
        window.setTimeout(setReal, 4000);
        window.setTimeout(setReal, 4030);
        window.setTimeout(setReal, 4200);

        //document.body.style.cssText="border:20px solid yellow;";


      } else {
        window.setTimeout(setReal, 200);
        window.setTimeout(setReal, 1000);

      }


    }

    imgEl.addEventListener('pointerdown', (e) => this.structuralAPI$OnImgPress(e), { once: true });
  }

}
